<template>
  <section class="gardenManagementPage">
    <g-breadcrumb bread="园所管理" />
    <SearchForm>
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px">
        <el-form-item prop="orgName">
          <el-input v-model.trim="searchForm.orgName" placeholder="请输入园所名称" />
        </el-form-item>
        <el-form-item>
          <el-cascader
            v-model="searchForm.areaIds"
            style="width: 350px;"
            :options="orgAreaTree"
            placeholder="请选择归属"
            clearable
            filterable
            collapse-tags
            :props="{ multiple: true, checkStrictly: false, emitPath: false, label: 'orgName', value: 'orgId' }"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="fetchData">搜 索</el-button>
        </el-form-item>
      </el-form>
    </SearchForm>
    <TableContainer title="园所列表">
      <template slot="button">
        <el-button type="success" @click="addGarden">添加园所</el-button>
      </template>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="orgCode" label="标号" min-width="160" />
        <el-table-column prop="orgName" label="园所名称" min-width="140" />
        <el-table-column prop="groupName" label="所属集团" min-width="100" />
        <el-table-column prop="areaName" label="所属片区" min-width="100" />
        <el-table-column prop="principalName" label="负责人" min-width="100" />
        <el-table-column prop="phone" label="手机号" min-width="100" />
        <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.remark"> {{ scope.row.remark }}</div>
            <div v-else> - -</div>
          </template>
        </el-table-column>
        <el-table-column width="120" label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="textGreen" @click="editGarden(scope.row)">编辑</el-button>
            <el-button type="text" class="textOrange" @click="deleteGarden(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <GPagination v-show="total > 0" ref="ref_GPagination" :total="total" :page.sync="searchForm.page" :size.sync="searchForm.size" @pagination="fetchData" />
    </TableContainer>
    <GDialog :dialog.sync="gardenDialog" @btnSure="submitForm('ref_gardenForm')" @btnClose="resetGardenForm('ref_gardenForm')">
      <el-form ref="ref_gardenForm" :model="gardenForm" :rules="rules" label-width="80px" class="demo-gardenForm">
        <el-form-item label="归属" prop="areaId">
          <el-cascader
            v-model="gardenForm.areaId"
            style="width: 100%;"
            :options="orgAreaTree"
            placeholder="请选择归属"
            clearable
            filterable
            collapse-tags
            :disabled="gardenDialog.title === '编辑园所'"
            :props="{ multiple: false, checkStrictly: false, emitPath: false, label: 'orgName', value: 'orgId' }"
          />
        </el-form-item>
        <el-form-item label="园所名称" prop="orgName">
          <el-input v-model.trim="gardenForm.orgName" maxlength="20" placeholder="请输入园所名称" />
        </el-form-item>
        <el-form-item label="负责人" prop="principalName">
          <el-input v-model.trim="gardenForm.principalName" :maxlength="18" placeholder="请输入负责人" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="gardenForm.phone" maxlength="11" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="gardenForm.remark" maxlength="200" show-word-limit type="textarea" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </GDialog>
  </section>

</template>

<script>
import { mapState } from 'vuex'
import { getOrgList, addOrg, updateOrg, delOrg } from '@api/gardenManagement/api_gardenManagement'
export default {
  data() {
    return {
      currentRow: {},
      gardenDialog: {
        title: '标题',
        visible: false
      },
      tableData: [],
      total: 0,
      searchForm: {
        orgName: '',
        areaIds: [],
        page: 1,
        size: 20
      },
      gardenForm: {
        areaId: '',
        orgName: '',
        principalName: '',
        phone: '',
        remark: ''
      },
      rules: {
        areaId: [{ required: true, message: '请选择归属', trigger: 'change' }],
        orgName: [{ required: true, message: '请输入园所名称', trigger: 'blur' }],
        principalName: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('commonModule', ['orgAreaTree', 'selectOptionsLevel'])
  },
  created () {
    this.getOptions()
    this.fetchData()
  },

  methods: {
    // ...mapMutations('commonModule', ['GET_SUBJECTTREE']),
    getOptions () {
      // 查询组织机构树-到片区；2到片区，3到园所
      this.$store.dispatch('commonModule/getOrgTree', 2)
    },
    fetchData() {
      this.searchForm.type = 3
      getOrgList(this.searchForm).then(res => {
        this.tableData = res.records
        this.total = res.total
      })
    },
    addGarden () {
      this.gardenDialog.visible = true
      this.gardenDialog.title = '添加园所'
    },
    editGarden (row) {
      this.gardenDialog.visible = true
      this.gardenDialog.title = '编辑园所'
      this.currentRow = row
      this.$nextTick(() => {
        this.gardenForm = { ...row }
      })
    },
    deleteGarden (row) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(async() => {
        this.currentRow = row
        try {
          await delOrg({ orgId: row.id })
          this.$message.success('删除成功！')
          if (this.total % this.searchForm.size === 1) {
            this.searchForm.page = this.searchForm.page - 1 === 0 ? 1 : this.searchForm.page - 1
          }
          this.fetchData()
        } catch (e) {
          this.$message.closeAll()
          this.$message.error(e)
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) { return false }
        const params = {
          ...this.gardenForm
        }
        let _api
        if (this.gardenDialog.title === '添加园所') {
          _api = addOrg
        } else {
          _api = updateOrg
          params.orgId = this.currentRow.id
        }
        try {
          await _api(params)
          this.$message.success(this.gardenDialog.title + '成功！')
          this.resetGardenForm('ref_gardenForm')
          this.fetchData()
        } catch (e) {
          this.$message.closeAll()
          this.$message.error(e)
        }
      })
    },
    resetGardenForm(formName) {
      this.$refs[formName].resetFields()
      this.gardenDialog.visible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
